export default class WorkHistoryJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.workHistoryEndpoint}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.workHistoryEndpoint}/${id}`, payload)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.workHistoryEndpoint, {
      params
    })
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.workHistoryEndpoint}/${id}`)
  }

  get(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.workHistoryEndpoint}/${id}`)
  }
}
